import { render } from "./Activation1Form.vue?vue&type=template&id=54968744&scoped=true"
import script from "./Activation1Form.vue?vue&type=script&lang=js"
export * from "./Activation1Form.vue?vue&type=script&lang=js"

import "./Activation1Form.vue?vue&type=style&index=0&id=54968744&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54968744"]])

export default __exports__